@if (remainingTime > 0) {
	<div class="timer">
		@if (options.isDaysDisplayed) {
			<span id="days">
				<span class="counter">{{ counterDays }}</span>
				jour(s)
			</span>
		}
		@if (options.isHoursDisplayed) {
			<span id="hours">
				<span class="counter">{{ counterHours }}</span>
				H
			</span>
		}
		@if (options.isMinutesDisplayed) {
			<span id="minutes">
				<span class="counter">{{ counterMinutes }}</span>
				mn
			</span>
		}
		@if (options.isSecondsDisplayed) {
			<span id="seconds">
				<span class="counter">{{ counterSeconds }}</span>
				s
			</span>
		}
	</div>
}
